import { IntegrityMonitorPauseDataProvider } from '../dataProvider/IntegrityMonitorPauseDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class IntegrityMonitorPauseDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorPauseDataProvider);
  }
}
